import { Type } from "class-transformer";
import { CommentOutDTO } from "./comment.out.dto";

export class CommentThreadOutDTO {
  @Type(() => CommentOutDTO)
  threads!: CommentOutDTO[][];
}
